module.exports = __webpack_public_path__ + "media/application/images/2018/2018-dir-red-lock-2a758279f7251418a3c17c955667efb7.svg";